import { inferRelationType } from '#layers/data-model/utils/relation';
import { defineFieldTypeTemplate } from '../define';

export default defineFieldTypeTemplate({
	type: 'relation',
	id: 'relation',
	icon: 'lucide:link',
	name: '$t:field_types.relation.name',
	description: '$t:field_types.relation.description',
	keywords: ['many-to-one', 'one-to-many', 'many-to-many', 'foreign key', 'reference', 'm2o', 'o2m', 'm2m', 'o2o'],
	supportedRelationTypes: ['o2m', 'm2o', 'o2o', 'm2m'],
	sort: 1000,
	displayFieldType: ({ field, i18n }) => {
		const relationType = inferRelationType(field);
		const relationTranslation = i18n.t('field_types.relation.name');
		const relationTypeName = i18n.t(`relation_types.${relationType}`);

		return `${relationTranslation} (${relationTypeName})`;
	},
});
